import React from "react";
import { Row, Col, Card, Button, Divider, Result, Typography } from "antd";
import { CheckCircleOutlined, LeftOutlined } from "@ant-design/icons";
import { HeaderPage } from "../../../components/headerPage";
import { HeaderTitle } from "../../../components/headerTitle";
import { useNavigate } from "react-router-dom";
const { Text } = Typography;

export const EleicoesCipaSucesso = ({ to }) => {
  const navigate = useNavigate();

  return (
    <Row align="middle" justify="center" className="content-row">
      <Col span={24} align="middle" justify="center">
        <Col xs={24} sm={24} md={22} lg={22} xl={20} xxl={16} align="left">
          <div className="content-item">
            <HeaderPage title="Eleições CIPA" onClickBack={() => navigate(to)} />
            <HeaderTitle
              title={["Eleições", "Lançamento", "Sucesso"]}
              subtitle="Eleição realizada com sucesso"
              icon={<CheckCircleOutlined />}
            />
            <Divider />
            <Card bordered={false} bodyStyle={{ padding: "3%" }}>
              <Result
                status="success"
                title={
                  <Text strong style={{ fontSize: 25 }}>
                    Seu voto foi computado com sucesso!
                  </Text>
                }
                extra={[
                  <Button
                    icon={<LeftOutlined />}
                    type="primary"
                    size="large"
                    key="console"
                    onClick={() => navigate("/")}>
                    Voltar
                  </Button>,
                ]}
              />
            </Card>
          </div>
        </Col>
      </Col>
    </Row>
  );
};
